<template>
  <div class="box-second">
    <p class="title-crumb">
          <el-breadcrumb separator-class="el-icon-arrow-right color3">
              <el-breadcrumb-item>技术交底</el-breadcrumb-item>
          </el-breadcrumb>
      </p>
    <div class="main">
      <!-- <div class="main-left">
        <el-tree :data="dataTree" ref="tree" :props="defaultProps" @node-click="handleNodeClick" node-key='id'
          highlight-current default-expand-all>
          <span class="span-ellipsis" slot-scope="{ node, data }"
            style="width: 100%;text-align: left;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
            <span :title="node.label" class="">{{data.name}}</span>
          </span>
        </el-tree>
      </div> -->
      <div class="main-table">
        <div class="table-head">
          <div class="table-head-seach">
            <span>名称：</span>
            <el-input placeholder="请输入文件名称" v-model="search.fileName" clearable style="margin-right:1vw;"></el-input>
            <span>交底类型：</span>
            <el-select v-model="search.fileType" filterable clearable placeholder="请选择">
              <el-option label="质量交底" value="9"></el-option>
              <el-option label="安全交底" value="10"></el-option>
            </el-select>
            <el-button style="margin-left:10px;background:#275bcf" type="primary" @click="doFile">查询</el-button>
          </div>
          <!-- <el-upload
              class="upload-demo"
              v-bind:action="uploadUrl"
              :headers="uploadHead"
              :data={type:225}
              :show-file-list="false"
              :on-success="fileSuccess">
              <el-button size="small" style="background: #285bd0;" type="primary" class="primary">点击上传</el-button>
          </el-upload> -->
          <el-button type="primary" v-if="isMenuExit('pro:tech:add')" size="mini" plain icon="el-icon-plus" @click="addTeam">添加
          </el-button>
        </div>
        <div class="table-box">
          <el-table :data="tableDataEnd" height="100%" style="width: 100%"
            :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
            <template slot="empty">
              <p>{{dataText}}</p>
            </template>
            <el-table-column label="序号" type="index" width="80"></el-table-column>
            <el-table-column label="交底类型">
              <template slot-scope="scope">
                <span v-if="scope.row.fileType=='9'">质量交底</span>
                <span v-if="scope.row.fileType=='10'">安全交底</span>
              </template>
            </el-table-column>
            <el-table-column label="交底名称" show-overflow-tooltip>
              <template slot-scope="scope">
                <span style="padding-left:1vw;">{{scope.row.fileName}}</span>
              </template>
            </el-table-column>
            <el-table-column label="内容">
              <template slot-scope="scope">
                <span>{{ scope.row.remark }}</span>
              </template>
            </el-table-column>
            <el-table-column label="交底图片">
              <template slot-scope="scope">
                <el-image style="width: 100px; height: 100px" :src="scope.row.url" :preview-src-list="scope.row.srcList"></el-image>
                <!-- <el-button type="success" v-if="scope.row.checkCode==0" size="mini"
                  @click="handleCheck(scope.$index, scope.row,1)">通过</el-button>
                <el-button type="warning" v-if="scope.row.checkCode==0" size="mini"
                  @click="handleCheck(scope.$index, scope.row,2)">不通过</el-button>
                <el-button type="danger" v-if="scope.row.checkCode!=0" size="mini">已审核</el-button> -->
              </template>
            </el-table-column>
            <!-- <el-table-column label="操作" width="250">
              <template slot-scope="scope">
                <el-button size="mini" @click="handleDown(scope.$index, scope.row)">下载</el-button>
                <el-button size="mini" @click="erCode(scope.$index, scope.row)">二维码</el-button>
                <el-popover placement="top" width="200" v-model="scope.row.visible">
                  <div>
                    <el-button size="mini" type="success" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                  </div>
                  <el-button slot="reference" style="margin-left:10px;" size="mini" type="primary">更多
                  </el-button>
                </el-popover>
              </template>
            </el-table-column> -->
          </el-table>
          <!-- 分页展示 -->
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="totalItems" style="padding-top:10px;">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 新增窗口 -->
    <!-- <el-dialog :title="entTitle" :visible.sync="entVisible" center :append-to-body="true" :lock-scroll="false"
      width="30%">
      <el-form :model="addFolder" ref="addFolder" :rules="rules" label-width="200px" label-position="right"
        class="joinEnt">
        <el-form-item label="文件名：" prop="fileName">
          <el-input v-model="addFolder.filesName" autocomplete="off" style="width:220px"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="entVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAddFolder('addFolder')">确 定</el-button>
      </div>
    </el-dialog> -->
    <!-- 审核弹出框 -->
    <!-- <el-dialog :title="codeTit" :visible.sync="codeVis" center :append-to-body="true" :lock-scroll="false" width="30%"
      style="height:100%;">
      <el-form :model="codeFrom" ref="codeFrom" :rules="rules" label-width="200px" label-position="right"
        class="joinEnt">
        <el-form-item label="备注:" prop="remark">
          <el-input type="textarea" v-model="codeFrom.remark" autocomplete="off" style="width:220px" :rows="16">
          </el-input>
        </el-form-item>
        <el-form-item label="审核人:" prop="remark">
          <el-input v-model="codeFrom.checkName" autocomplete="off" style="width:220px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="codeVis = false">取 消</el-button>
        <el-button type="primary" @click="codeVisAddRow('codeFrom')">确 定</el-button>
      </div>
    </el-dialog> -->
    <!-- 二维码弹出框 -->
    <!-- <el-dialog :title="codeTit" :visible.sync="codeVis1" center :append-to-body="true" :lock-scroll="false" width="30%"
      style="height:100%;" :before-close="handleCloseback">
      <div class="erCode">
        <vue-qr :text="codeUrl" :size="200"></vue-qr>
      </div>
    </el-dialog> -->
    <!-- 添加文件 -->
    <el-dialog :title="diaTitle" :visible.sync="addFormVisible" center :append-to-body="true" :lock-scroll="false"
      width="40%">
      <el-form :model="addForm" ref="addForm" label-width="150px" label-position="right" class="teamPage"
        :rules="teamRules">
        <el-form-item label="名称:">
          <el-input v-model="addForm.fileName" autocomplete="off" style="width:220px"></el-input>
        </el-form-item>
        <el-form-item label="类型:">
          <!-- <el-input v-model="addForm.fileType" autocomplete="off" style="width:220px"></el-input> -->
          <el-select v-model="addForm.fileType" placeholder="请选择">
            <el-option label="质量交底" value="9"></el-option>
            <el-option label="安全交底" value="10"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交底内容：">
          <el-input v-model="addForm.remark" type="textarea" placeholder="请输入内容" autocomplete="off" style="width:220px"
            :rows="5"></el-input>
        </el-form-item>
        <el-form-item label="交底图片:">
          <el-upload style="display: flex;padding: 20px 30px;" accept="image/*" :action="uploadphotoUrl" list-type="picture-card"
            :on-preview="handlePictureCardPreview" :headers="uploadHead" :data="uploadphotoData"
            :on-success="handleIconSuccess">
            <i class="el-icon-plus"></i>
          </el-upload>
          <!-- <el-upload class="upload-demo" v-bind:action="uploadUrl" :headers="uploadHead"
            :data={type:245,projectId:groupId} :show-file-list="false" :on-success="fileSuccess">
            <i v-if="!addForm.fileUrl" class="el-icon-plus avatar-uploader-icon"></i>
            <div style="display: flex;justify-content: space-between;align-items: center;">
              <img v-if="addForm.fileUrl" src="../../assets/image/fileicon.png" style="width:5vh;height:5vh;" />
              <span v-if="addForm.fileUrl">{{addForm.fileName}}</span>
            </div>

          </el-upload> -->
        </el-form-item>
        <!-- <el-form-item label="排序:" prop="sort">
          <el-input v-model="addForm.sort" autocomplete="off" style="width:220px"></el-input>
        </el-form-item>
        <el-form-item label="提交人">
          <el-input v-model="addForm.createBy" placeholder="请输入内容" autocomplete="off" style="width:220px"></el-input>
        </el-form-item> -->
        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 审批流弹框 -->
    <!-- <el-dialog :title="processTitle" :visible.sync="processVisible" center :append-to-body="true"
      :before-close="handleCloseprocess" :lock-scroll="false" width="35%" height="700px">
      <div style="height: 350px;    overflow: auto;">
        <el-steps direction="vertical">
          <el-step v-for="(item,index) in processList" :key="index" process-status="success">
            <template slot="description">
              <div>
                <div class="stepNoBtn">
                  <div class="step-title-font">处理人:{{ item.createBy }}</div>
                  <div class="step-title-font">处理时间:{{ item.createDate }}</div>
                  <div>处理意见：{{item.fileRemark||'无'}}</div>
                </div>
              </div>
            </template>
          </el-step>
        </el-steps>
      </div>
    </el-dialog> -->
  </div>
</template>
<script>
  import util from '../../untils/util'
  import myHttp from '../../untils/port'
  import base from '../../untils/base'
  import vueQr from 'vue-qr'
  export default {
    components: {
      vueQr
    },
    data() {
      return {

        projectId: '',
        dataTree: [],
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        entName: '',//参建单位查询
        groupId: '',
        folderList: [],//参建单位list
        entsTypes: [],//参建单位类型list
        entTitle: '',//参建单位弹出框名称
        entVisible: false,
        persons: [],//参建单位的管理人员
        addFolder: {
          filesType: '1',
          type: '1',
          id: '',
          groupId: '',
          filesName: '',
          userType: ''
        },
        search: {
          fileName: '',
          fileType: '9'
        },
        rules: {
          filesName: [
            { required: true, message: '请填写文件名称', trigger: 'blur' }
          ],
        },
        folderId: '',//当前展示文件夹id
        tableDataEnd: [],//班组列表
        diaTitle: '添加文件夹',//班组添加名称
        dataText: '数据加载中...',
        teamName: '',//班组名称
        uploadUrl: base.url + "/upload/uploadFile",//上传地址
        uploadHead: {  //上传接口header
          accessToken: this.$store.state.token
        },
        //二维码
        codeVis: false,
        codeUrl: '',
        codeTit: '',
        diaTitle: '添加',//班组添加名称
        addFormVisible: false,//班组添加弹出框
        teamRules: {},
        addForm: {
          id: '',
          fileName: '',
          fileSize: '',
          fileType: '',
          fileUrl: '',
          remark: '',
          sort: '',
          createBy: ''
        },
        currentPage: 1,
        pageSize: 10,
        totalItems: 0,
        codeFrom: {
          fileId: '',
          checkCode: '',
          remark: '',
          checkName: ''
        },
        codeVis1: false,
        prot: '',
        statusList: [{ name: '未审核', id: '0' }, { name: '审核成功', id: '1' }, { name: '审核失败', id: '2' },],
        processTitle: '流程',
        processVisible: false,
        processForm: {

        },
        tableDataEnd: [],
        processList: [],

        //上传
        uploadphotoUrl: base.url + '/upload/uploadPhoto', //上传地址
        uploadHead: {
          accessToken: util.session.get('token'),
        },
        uploadphotoData: {
          type: '203',
        },
        fileList: [],
      }
    },
    mounted() {
      this.prot = util.session.get('roleId')
      this.groupId = util.session.get('groupId')

      this.getFolder()
      // this.getPerson()
    },
    methods: {
      handleSizeChange(val) {
        this.pageSize = val
        this.handleCurrentChange(this.currentPage)
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.currentChangePage()
      },
      // 监控当前页码
      currentChangePage(list) {
        this.getFolder()
      },
      getTreeData() {
        var that = this
        myHttp.findOfficeTreeList({
          entId: this.groupId,
          // levelType:3
        }).then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data || []
            var curKey = ''
            var projectId = ''
            if (list.length > 0) {
              curKey = list[0].children[0].id
              that.dataTree = list
              that.projectId = curKey
              that.getFolder()
            } else {

            }
            setTimeout(function () {
              that.$refs.tree.setCurrentKey(curKey)
            }, 100)
          }
        })
      },
      //获取文件夹
      getFolder() {
        var that = this
        this.tableDataEnd = []
        myHttp.findProjectFileList({
          fileType: this.search.fileType,
          projectId: this.groupId,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          fileName: this.search.fileName
        }).then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.list || []
            if (list.length > 0) {
              for (var i = 0; i < list.length; i++) {
                list[i].visible = false
                list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
                list[i].fileFormat = list[i].fileName && list[i].fileName != '' ? that.getImg(list[i].fileName) : '0'
                var imgs = list[i].fileUrl.split(',')
                list[i].srcList = []
                for(var j=0;j<imgs.length;j++){
                  list[i].srcList.push(base.httpCtx+imgs[j])
                }
                list[i].url  = base.httpCtx+imgs[0]
              }
              that.tableDataEnd = list
              that.totalItems = resp.data.data.total
            } else {
              that.dataText = '暂无数据'
            }
            that.folderList = list
          } else {

          }
        })
      },
      doFile() {
        this.getFolder()
      },
      //添加参建单位
      addEntFun() {
        this.entVisible = true
        this.addFolder.filesName = ''
        this.addFolder.id = ''
        this.entTitle = '添加文件夹'

      },

      //添加或者修改文件夹
      sumbitAddFolder(formName) {
        var that = this
        // this.addFolder.createBy = util.session.get('user').id
        this.addFolder.groupId = this.groupId
        this.addFolder.userType = util.session.get('roleId')
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.addFolder.id == '') {
              myHttp.addFolderFiles(this.addFolder).then(function (resp) {
                if (resp.data.code == '200') {
                  that.$message.success('添加成功')
                  that.entVisible = false
                  that.getFolder()
                } else {
                  that.$message.error(resp.data.msg)
                }
              })
            } else {
              myHttp.updateFiles(this.addFolder).then(function (resp) {
                if (resp.data.code == '200') {
                  that.$message.success('修改成功')
                  that.entVisible = false
                  that.getFolder()
                } else {
                  that.$message.error(resp.data.msg)
                }
              })
            }
          } else {
            return false
          }
        })
      },
      //选择展示的文件夹
      // getEntId(row) {
      //   this.folderId = row.id
      //   this.getData()
      // },

      /***
       * 获取文件
       */
      // getData() {
      //   var that = this
      //   myHttp.findProjectFileList({
      //     projectId: this.projectId
      //   }).then(function (resp) {
      //     if (resp.data.code == '200') {
      //       var list = resp.data.data.Files || []
      //       for (var i = 0; i < list.length; i++) {
      //         list[i].fileFormat = list[i].fileName && list[i].fileName != '' ? that.getImg(list[i].fileName) : '0'
      //       }
      //       that.tableDataEnd = list
      //       if (that.tableDataEnd.length == 0) {
      //         that.dataText = '暂无数据'
      //       }
      //     } else {
      //       that.$message.error(resp.data.msg)
      //       that.dataText = '暂无数据'
      //     }
      //   })
      // },
      //获取图片
      getImg(url) {
        // 1:word   2:excel    3:pdf     4:img   5:undefined
        var result = '';
        var list = url.split('.')
        var str = list[list.length - 1]
        if (base.docType.indexOf(str) >= 0) {
          result = '1'
        } else if (base.imgType.indexOf(str) >= 0) {
          result = '4'
        } else if (base.excelType.indexOf(str) >= 0) {
          result = '2'
        } else if (base.pdfType.indexOf(str) >= 0) {
          result = '3'
        } else {
          result = '5'
        }
        return result
      },
      /**
       * 根据名称查询班组
       */
      doFilter() {
        this.getTeam()
      },
      /**
       * 添加文件
       */
      addTeam() {
        this.addFormVisible = true
        // this.teamPersons = []
        // this.getPerson()
        this.addForm = {
          fileId: '',
          fileName: '',
          fileSize: '',
          fileType: '',
          fileUrl: '',
          remark: '',
          sort: '',
          createBy: ''
        }
        this.diaTitle = '添加'
      },
      // 修改文件
      handleEdit(index, row) {
        this.addFormVisible = true
        this.addForm.fileId = row.fileId
        // this.addForm.projectId = row.projectId
        this.addForm.fileName = row.fileName
        this.addForm.fileSize = row.fileSize
        this.addForm.fileType = row.fileType
        this.addForm.fileUrl = row.fileUrl
        this.addForm.remark = row.remark
        this.addForm.sort = row.sort
        this.addForm.createBy = row.createBy
        this.diaTitle = '修改'
      },
      //展示
      showFile(row) {
        var that = this
        // window.open(base.httpCtx + '/onlinePreview?url=' + encodeURIComponent(base.httpCtx + row.fileUrl), "_blank");
        window.open(base.httpCtx + row.fileUrl);
      },
      //下载
      handleDown(index, row) {
        window.open(base.httpCtx + row.fileUrl)
      },
      // 删除班组
      handleDelete(index, row) {
        var that = this
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          myHttp.deleteProjectFile({
            fileId: row.fileId,
            // updateBy: util.session.get('user').id
          }).then(function (resp) {
            if (resp.data.code == '200') {
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
              that.getFolder()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
        }).catch(err => { })
      },
      //上传成功
      fileSuccess(res, file, opt) {
        var that = this
        if (res.code == 200) {
          // console.log(res)
          // console.log(file)
          this.addForm.fileType = '4',
            this.addForm.fileName = file.name,
            this.addForm.fileUrl = res.data.fileUrl,
            this.addForm.fileSize = res.data.fileSize,
            this.addForm.projectId = this.groupId
          // this.addForm.createBy = util.session.get('user').id

          // myHttp.addFolderFiles(obj).then(function(resp){
          //     if(resp.data.code=='200'){
          //         that.$message.success('添加成功')
          //         that.getData()
          //     }else{
          //         that.$message.error(resp.data.msg)
          //     }
          // })
        } else {
          this.$message.error(res.msg);
        }

      },
      //编辑文件夹
      editFolder(obj) {
        this.entVisible = true
        this.addFolder.filesName = obj.filesName
        this.addFolder.id = obj.id

        this.entTitle = '修改文件夹'

      },
      //删除文件夹
      delFolder(obj) {

        var that = this
        this.$confirm('此操作将永久删除该文件夹及其中的文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          myHttp.deleteFiles({
            id: obj.id,
            updateBy: util.session.get('user').id
          }).then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('删除成功')
              that.getFolder()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
        })
      },
      // 将新增的数据添加到表格中
      sumbitAddRow(formName) {
        var that = this
        // console.log(this.addForm)
        // this.addForm.userId = this.$store.state.user.id
        this.addForm.projectId = util.session.get('groupId')
        for(var i=0;i<this.fileList.length;i++){
          if(this.addForm.fileUrl==''){
            this.addForm.fileUrl = this.fileList[i].response.data.saveUrls
          }else{
            this.addForm.fileUrl += ','+ this.fileList[i].response.data.saveUrls
          }
        }
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.addForm.fileId == '') {
              myHttp.addProjectFile(this.addForm).then(function (resp) {
                if (resp.data.code == '200') {
                  that.$message.success('添加成功')
                  that.addFormVisible = false
                  that.getFolder()
                } else {
                  that.$message.error(resp.data.msg)
                }
              })
            } else {
              myHttp.editProjectFile(this.addForm).then(function (resp) {
                if (resp.data.code == '200') {
                  that.$message.success('修改成功')
                  that.addFormVisible = false
                  that.getFolder()
                } else {
                  that.$message.error(resp.data.msg)
                }
              })
            }
          } else {
            //console.log('error submit!!')
            return false
          }
        })
      },
      codeVisAddRow(formName) {
        var that = this
        this.$refs[formName].validate(valid => {
          if (valid) {
            // if (this.addForm.id == '') {
            myHttp.checkProjectFile(this.codeFrom).then(function (resp) {
              if (resp.data.code == '200') {
                that.$message.success('提交成功')
                that.codeVis = false
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
            // } 
          } else {
            //console.log('error submit!!')
            return false
          }
        })
      },
      //展示二维码
      erCode(index, row) {
        this.codeVis1 = true
        this.codeUrl = base.httpCtx + row.fileName
        this.codeTit = row.fileName
      },
      /**
         * 点击
         */
      handleNodeClick(e) {
        console.log(e)
        // if(e.level=='1'){
        //     this.opt.projectId = ''
        //     this.opt.entId = ''
        // }else if(e.level=='2'){
        //     this.opt.projectId = e.id
        //     this.opt.entId = ''
        // }else{
        //     this.opt.projectId = e.parentId
        //     this.opt.entId = e.id
        // }
        this.tableDataEnd = []
        this.projectId = e.id
        this.getFolder()
      },
      handleCheck(index, row, checkCode) {
        this.codeFrom.checkCode = checkCode,
          this.codeFrom.fileId = row.fileId,
          this.codeVis = true
        var that = this
        // this.$confirm('此操作将永久, 是否继续?', '提示', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        // }).then(() => {
        //     myHttp.deleteFiles({
        //         id: obj.id,
        //         updateBy:util.session.get('user').id
        //     }).then(function(resp) {
        //         if (resp.data.code == '200') {
        //         that.$message.success('删除成功')
        //         that.getFolder()
        //         } else {
        //         that.$message.error(resp.data.msg)
        //         }
        //     })
        // })
      },
      handleCloseback() {
        this.codeVis1 = false
      },
      proccess(index, row) {
        this.processVisible = true
        this.processForm.fileId = row.fileId
        this.getProcess()
      },
        /**
       * 判断是否展示
       */
      isMenuExit(row){
          var flag = util.common.filterBtnMenu(row)
          return flag
      },
      getProcess() {
        var that = this
        this.processList = []
        myHttp.findProjectFileRecordList(this.processForm).then(function (resp) {
          if (resp.data.code == "200") {
            var list = resp.data.data
            that.processList = list
          } else {
            that.$message.error(resp.data.msg);
          }
        }, function () { });
      },

      handleIconSuccess(res, file, opt, other) {
        if (res.code == '200') {
          // console.log(opt)
          // console.log(res)
          this.fileList = opt
          // var picUrls =[]
          // for(var i=0;i<opt.length;i++){
          //   picUrls.push(opt[i].response.data.saveUrls)
          // }
          // console.log(picUrls)
        } else {
          this.$message.error(res.msg)
        }
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url
        this.dialogVisible = true
      },
      handleRemove(file, fileList) {
        console.log(fileList)
        this.fileList = fileList
      },


    }

  }
</script>
<style scoped>
  
  .main-left-search {
    width: 100%;
    height: 10%;
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    padding: 1vh;
  }

  .main-left-p {
    width: 100%;
    height: 7%;
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: space-between;
    padding: 0 1vh;
  }

  .main-left-list {
    width: 100%;
    height: 85%;
    position: relative;
    overflow: auto;
  }

  .main-left-list li {
    width: 100%;
    /* height: 9vh; */
    position: relative;
    padding: 2px;
    /* display: flex; */
    align-content: center;
    align-items: center;
    border-bottom: 1px solid #eee;
    cursor: pointer;
  }

  .main-left-list li:hover {
    background: #eee;
  }

  .curEnt {
    background: #E7F1FB;
  }

  .curEnt i,
  .curEnt p {
    color: #5A87F9;
  }

  /* .unit-type{
      width: 20%;
      height: 100%;
      position: relative;
      display: flex;
      justify-content: center;
      justify-items: center;
      align-items: center;
      align-content: center;
      border: 1px solid #0365F2;
      padding: 1.5%;
  } */
  .unit-name {
    width: 80%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    align-content: center;
    padding-left: 1vh;
    flex-wrap: wrap;
  }

  .unit-name p {
    width: 100%;
    text-align: left;
  }

  .main-table {
    /* width: calc(100% - 220px); */
    height: calc(100% - 60px);
    position: relative;
    padding-left: 10px;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }

  .table-head {
    width: 100%;
    height: 6vh;
    position: relative;
    background: #fff;
    border-top-left-radius: 0.5vh;
    border-top-right-radius: 0.5vh;
    display: flex;
    align-content: center;
    align-items: center;
    padding: 2vh;
    justify-content: space-between;
  }

  .table-head-seach {
    width: 90%;
    height: 100%;
    position: relative;
    align-items: center;
    display: flex;
  }

  .table-box {
    width: 100%;
    height: calc(100% - 6vh);
    position: relative;
    background: #fff;
    border-bottom-left-radius: 0.5vh;
    border-bottom-right-radius: 0.5vh;
  }

  .box-ent {
    width: 100%;
    height: 10vh;
    position: relative;
    margin-bottom: 1vh;
    background: #fff;
    border-radius: 5px;
    display: flex;
    /* flex-wrap: wrap; */
  }

  .box-ent-l {
    width: 80%;
    height: 100%;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    padding: 2vh;
    align-content: center;
    align-items: center;
  }

  .box-ent-l p {
    width: 33%;
    height: 3vh;
    position: relative;
    text-align: left;
    padding-right: 1vh;
  }

  .box-ent-r {
    width: 20%;
    height: 100%;
    display: flex;
    align-content: center;
    align-items: center;
  }

  .erCode {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    justify-items: center;
    align-content: center;
    align-items: center;
    flex-wrap: wrap;
  }

  .stepNoBtn {
    color: #000;
    height: 110px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
</style>
<style>
  @import '../../assets/css/common.css';

  /* .el-table--border th,
  .el-table__fixed-right-patch {
    border-bottom: 1px solid #303133;
  }

  .el-table--border td,
  .el-table--border th,
  .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
    border-right: 1px solid #303133;
  }

  .el-table td,
  .el-table th.is-leaf {
    border-bottom: 1px solid #303133;
  }

  .el-table--border,
  .el-table--group {
    border: 1px solid #303133;
  } */
</style>